import * as React from 'react';
import type {SVGProps} from 'react';

export function Iep2(props: SVGProps<SVGSVGElement>): JSX.Element {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='none'
			viewBox='0 0 32 32'
			{...props}
		>
			<path
				fill='#333'
				fillRule='evenodd'
				d='M16 26.714c5.917 0 10.714-4.797 10.714-10.714 0-5.917-4.797-10.714-10.714-10.714-5.917 0-10.714 4.797-10.714 10.714 0 5.917 4.797 10.714 10.714 10.714ZM16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12Z'
				clipRule='evenodd'
			/>
			<path
				fill='#333'
				fillRule='evenodd'
				d='M19.824 14.451c0 2.052-1.712 3.715-3.824 3.715s-3.824-1.663-3.824-3.715c0-2.051 1.712-3.714 3.824-3.714s3.824 1.663 3.824 3.714Zm-1.55 0c0-1.714-1.284-2.238-2.274-2.238-1.01 0-2.275.524-2.275 2.238 0 1.286 1.285 2.238 2.275 2.238s2.275-.952 2.275-2.238ZM16.5 20c2.4 0 6.33 2.075 7 4.5-.198.051-.287.5-.5.5l-.5.5c-.5-1.5-3.51-4-6-4h-1c-2.663 0-5.5 2.5-6 4L9 25c-.212 0-.303.047-.5 0v-.5c.637-2.476 4.575-4.5 7-4.5h1Z'
				clipRule='evenodd'
			/>
			<path
				fill='#333'
				fillRule='evenodd'
				d='M16 26.25c5.66 0 10.25-4.59 10.25-10.25S21.66 5.75 16 5.75 5.75 10.34 5.75 16 10.34 26.25 16 26.25ZM16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12Z'
				clipRule='evenodd'
			/>
		</svg>
	);
}
